// FadeIn
import 'view-base/type-style/hidden.css';

// Set Font
// import 'view-base/type-font/opensans.css'
// Find view
import debounce from 'lodash/debounce';
// // Add $ Shortcut
import 'view-base/util-dom';

// ---------------------
// Setup data provider
// ---------------------
import { dispatch } from './data-store';
import { uri, meta } from './data-util';
import { initialize } from './data-thunk/initialize.js';
import { router } from './data-thunk/router.js';

// ----------------
// Clinic
// ----------------
window.onload = async () => {
  // Prepare everything before render loop starts
  const ready = await dispatch(initialize());
  // Start sequence with server call ok
  if (ready == 'go') {
    // Set robots to true if production domain
    meta.robots(location && location.hostname == 'epha.health');
    // meta.robots( true )
    // Start to render view and don't push state
    await dispatch(router(null, null, 'replace'));
    // Show view for the first time and give some time to be ready
    // Static Render will wait for 500ms
    await new Promise((res) => setTimeout(res, 250));
  }
  // Too many drugs in startup without authorization
  else if (ready == 'not-authorized') {
    await dispatch(router('not-authorized'));
  }
  // Server could not be reached
  else {
    await dispatch(router('error'));
  }

  document.body.style.visibility = 'visible';

  if (!('scrollBehavior' in document.documentElement.style)) {
    // Activates polyfill
    document.documentElement.setAttribute('scroll-behavior', 'smooth');
    // Load
    await import('scroll-behavior-polyfill');
  }
};

// Don't keep scroll status
history.scrollRestoration = 'manual';

// location.pathname is changed by the browser
window.onpopstate = function (e) {
  window.onload();
};

// --------------------------------------
// Refresh on revisiting tab
// --------------------------------------
const page = {};

if (typeof window !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  if (typeof document.hidden !== undefined) {
    page.hidden = 'hidden';
    page.visibilityChange = 'onvisibilitychange';
  } else if (typeof document.msHidden !== undefined) {
    page.hidden = 'msHidden';
    page.visibilityChange = 'onmsvisibilitychange';
  } else if (typeof document.webkitHidden !== undefined) {
    page.hidden = 'webkitHidden';
    page.visibilityChange = 'onwebkitvisibilitychange';
  }
} else {
  console.log('document.hidden not supported in nodejs');
}

// ---------------------------------------
// Page tab can be hidden and will
// activate if tab is selected in browser
// ---------------------------------------
if (page.visibilityChange) {
  // Check for activation
  document[page.visibilityChange] = async function (e) {
    // Activated
    if (document[page.hidden] == false) {
      // window.onload()
    }
  };
}
